import { DefaultResponseWithData } from "./system";

export interface IShippingAddress {
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  postcode: string;
  stateOrProvince: string;
  fullName: string;
}

export interface IShippingDimensions {
  weight: number;
  height: number;
  length: number;
  width: number;
}

export interface IShippingProoviaRequest {
  prooviaItemId: number;
  collectionDate: string;
  deliverDate: string;
}

export interface IShippingLabelCreateRequest {
  partDataId: string;
  service: string;
  width: number;
  height: number;
  length: number;
  weight: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  postcode: string;
  stateOrProvince: string;
  fullName: string;
  prooviaItemId?: number;
  collectionDate?: string;
  deliveryDate?: string;
  labelType?: ShippingLabelType;
}

// OLD

export interface IShippingLabelCreateFormFields {
  weight: number | null;
  height: number | null;
  length: number | null;
  width: number | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  county: string | null;
  postcode: string | null;
  stateOrProvince: string | null;
  fullName: string | null;
  prooviaItemId: number | null;
  collectionDate: string | null;
  deliveryDate: string | null;
}

export interface IShippingQuotes
  extends DefaultResponseWithData<IShippingQuote[]> {}

export interface ICustomShippingRequest {
  partDataId: string;
  trackingNumber: string;
  carrier: string;
}

export interface IShippingQuotesRequest {
  prooviaItemId?: number;
  partDataId: string;
  postcode: string;
  width: number;
  height: number;
  length: number;
  weight: number;

  providerId?: string;
}

export interface IShippingCreateRequest {
  partDataId: string;
  postcode: string;
  width: number;
  height: number;
  length: number;
  weight: number;
  service: string;
}

export interface IShippingQuote {
  service: string;
  name: string;
  price: number;
}

export interface IShippingInfoResponse
  extends DefaultResponseWithData<IShippingInfo> {}

export interface IShippingInfo {
  companyName: string;
  contactAddress: ContactAddress;
  email: string;
  fullName: string;
  primaryPhone: PrimaryPhone;
}

export interface ContactAddress {
  addressLine1: string;
  addressLine2: string;
  city: string;
  countryCode: string;
  county: string;
  postalCode: string;
  stateOrProvince: string;
}

export interface PrimaryPhone {
  phoneNumber: string;
}

export interface IProoviaItemsResponse
  extends DefaultResponseWithData<IProoviaItem[]> {}

export interface IProoviaItem {
  id: number;
  name: string;
  price: number;
  width: number;
  height: number;
  length: number;
  weight: number;
  dimensionUnit: string;
  weightUnit: string;
}

export interface IProoviaCollectionSlotRequest {
  from: string;
  to: string;
}

export interface IProoviaDeliverySlotRequest
  extends IProoviaCollectionSlotRequest {
  collectionDate: string;
}

export interface IProoviaSlot {
  date: string;
}

export interface IProoviaShippingCreateRequest extends IShippingCreateRequest {
  prooviaItemId: number;
  collectionDate: string;
  deliveryDate: string;
}

export enum ShippingLabelType {
  S16,
  SixByFour,
  FourBySix,
}